/**
 * The page's side of the offline worker: registering it in production builds and telling it
 * whose data it is saving.
 */

type WorkerMessage = { type: 'identity'; identity: string | null } | { type: 'clear' };

export function registerOfflineWorker() {
  if (!import.meta.env.PROD || typeof navigator === 'undefined' || !('serviceWorker' in navigator)) return;
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch(() => {
      // The app works without it; it just cannot open offline.
    });
  });
}

export function tellOfflineWorker(message: WorkerMessage) {
  if (typeof navigator === 'undefined' || !('serviceWorker' in navigator)) return;
  navigator.serviceWorker.ready
    .then((registration) => registration.active?.postMessage(message))
    .catch(() => undefined);
}
